import { ISchema, PaywallComponentProps } from '../../../@types'
import { mergeDeep } from '@/helpers/utils'

// Gift-box ("price before scratch card") treatment for the `activity-male-walking` funnel. The
// experiment targets US, where the rendered base paywall is instances/areas/walking/walking-m-us.ts
// (plans 7/30/90-day, most-popular on the 90-day) — the plan titles below mirror that base. Swaps
// the static PaywallPlanPicker for a removeDiscount-aware PaywallPlanPickerComp so the full price is
// shown until the gift box is picked, then the discount is revealed.
export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				giftBoxModal: true,
				initialDiscount: false,
				countdown: { autoStart: false },
			},
			order: [
				...schema.order.map((item) => (item === 'PaywallPlanPicker' ? 'PaywallPlanPickerComp' : item)),
				'PaywallGiftBoxModal',
			],
			components: {
				PaywallPlanPickerComp: ({ ctx, $t }): PaywallComponentProps.PlanPickerComp => ({
					items: [
						{
							title: {
								text: $t('pages.program.cheap_and_short.plans.7_days.period_text'),
								uppercase: true,
							},
							subtitle: {
								text: ctx.removeDiscount ? '{trial_price}' : `<s>{original_trial_price}</s> {trial_price}`,
								color: 'secondary',
							},
							price: {
								template: 'labeled-price',
								extras: {
									originalPrice: ctx.removeDiscount ? '' : '{original_trial_price_per_day_calculated}',
									dollars: '{trial_price_per_day_dollars}',
									cents: '{trial_price_per_day_cents}',
									period: $t('pages.program.cheap_and_short.common.planPicker.perDay'),
								},
							},
						},
						{
							title: {
								text: $t('pages.program.cheap_and_short.plans.30_days.period_text'),
								uppercase: true,
							},
							subtitle: {
								text: ctx.removeDiscount ? '{price}' : '<s>{price}</s> {trial_price}',
								color: 'secondary',
							},
							price: {
								template: 'labeled-price',
								badge: ctx.removeDiscount
									? null
									: $t('pages.program.plan_picker.badge.percent_off_uppercase', { percent: ctx.discountPercent }),
								extras: {
									originalPrice: ctx.removeDiscount ? '' : '{original_trial_price_per_day_calculated}',
									dollars: ctx.removeDiscount ? '{price_per_day_dollars}' : '{trial_price_per_day_dollars}',
									cents: ctx.removeDiscount ? '{price_per_day_cents}' : '{trial_price_per_day_cents}',
									period: $t('pages.program.cheap_and_short.common.planPicker.perDay'),
								},
							},
						},
						{
							title: {
								text: $t('pages.program.cheap_and_short.plans.90_days.period_text'),
								uppercase: true,
							},
							badge: {
								text: $t('pages.program.cheap_and_short.common.planPicker.mostPopular'),
								uppercase: true,
							},
							subtitle: {
								text: ctx.removeDiscount ? '{price}' : '<s>{price}</s> {trial_price}',
								color: 'secondary',
							},
							price: {
								template: 'labeled-price',
								badge: ctx.removeDiscount
									? null
									: $t('pages.program.plan_picker.badge.percent_off_uppercase', { percent: ctx.discountPercent }),
								extras: {
									originalPrice: ctx.removeDiscount ? '' : '{original_trial_price_per_day_calculated}',
									dollars: ctx.removeDiscount ? '{price_per_day_dollars}' : '{trial_price_per_day_dollars}',
									cents: ctx.removeDiscount ? '{price_per_day_cents}' : '{trial_price_per_day_cents}',
									period: $t('pages.program.cheap_and_short.common.planPicker.perDay'),
								},
							},
						},
					],
					bulletType: 'dot',
				}),
				PaywallGiftBoxModal: ({ ctx }): PaywallComponentProps.GiftBoxModal => ({
					discountPercent: ctx.giftBoxDiscountPercent,
				}),
			},
		},
	)
